import { eAccessControlUserType } from '../../../ui-toolkit/enums/eAccessControlUserType';
import { useGetMyTokenData } from 'components/accessControl/hooks/useGetMyTokenData';
import { IAuth0JSONWebToken } from 'types/accessControl/IAuth0JSONWebToken';
import { spruceClaimsFieldName } from 'types/accessControl/AccessControlConstants';
import { useGetMeQuery } from '../../../API/BaseApi';
import { IZillowUserData } from '../../../types/accessControl/IZillowUserData';

export const useMyClientId = () => {
  const tokenData = useGetMyTokenData();
  return (tokenData && getMyClientId(tokenData)) || undefined;
};

export const getMyClientId = (token: IAuth0JSONWebToken) => {
  if (spruceClaimsFieldName in token && token[spruceClaimsFieldName].ssn_type === eAccessControlUserType.Client) {
    return token[spruceClaimsFieldName].oid;
  }

  return undefined;
};

export const useMyUserId = () => {
  const tokenData = useGetMyTokenData();
  return tokenData?.[spruceClaimsFieldName]?.sid;
};

export const useMyZillowUserData = (): IZillowUserData => {
  const { data } = useGetMeQuery();
  return {
    zuid: data?.zuid,
    memento: data?.memento,
  }
};
